import React, { FunctionComponent } from "react"
import { useTranslation } from "react-i18next"

import Modal from "components/Modal/Modal"
import Text from "components/Text/Text"

export interface ICopyAssetHelpModalProps {
    onClose(): void
}

const NOT_COPIED_KEYS = [
    "copyAsset.help.notCopiedLabels",
    "copyAsset.help.notCopiedConnected",
    "copyAsset.help.notCopiedRequests",
    "copyAsset.help.notCopiedMaintenance",
    "copyAsset.help.notCopiedAttachments",
    "copyAsset.help.notCopiedInvoices",
    "copyAsset.help.notCopiedEvaluation",
    "copyAsset.help.notCopiedHistories",
]

/**
 * Explains the copy dialog's special and hardcoded behaviours: the
 * shared-defaults inheritance, the LMID modes, the values the system sets on
 * every copy, which data is never copied, and the copy limit.
 */
const CopyAssetHelpModal: FunctionComponent<React.PropsWithChildren<ICopyAssetHelpModalProps>> = ({
    onClose,
}) => {
    const { t } = useTranslation()

    return (
        <Modal
            title={t('copyAsset.help.title')}
            onClose={onClose}
            closeButton
            maxWidth="640px">
            <Text type="p" className="mb-3">{t('copyAsset.help.intro')}</Text>

            <Text type="h5" className="mb-1">{t('copyAsset.help.valuesTitle')}</Text>
            <Text type="p" className="mb-1">{t('copyAsset.help.valuesShared')}</Text>
            <Text type="p" className="mb-3">{t('copyAsset.help.valuesIndividual')}</Text>

            <Text type="h5" className="mb-1">{t('copyAsset.help.lmidTitle')}</Text>
            <ul className="mb-3">
                <li>
                    <Text type="p"><strong>{t('lmidModal.enterLmid')}</strong> — {t('copyAsset.help.lmidEnter')}</Text>
                </li>
                <li>
                    <Text type="p"><strong>{t('lmidModal.requestLmid')}</strong> — {t('copyAsset.help.lmidRequest')}</Text>
                </li>
                <li>
                    <Text type="p"><strong>{t('lmidModal.enterLmidLater')}</strong> — {t('copyAsset.help.lmidLater')}</Text>
                </li>
            </ul>

            <Text type="h5" className="mb-1">{t('copyAsset.help.fixedTitle')}</Text>
            <ul className="mb-3">
                <li><Text type="p">{t('copyAsset.help.fixedOperational')}</Text></li>
                <li><Text type="p">{t('copyAsset.help.fixedCondition')}</Text></li>
                <li><Text type="p">{t('copyAsset.help.fixedHours')}</Text></li>
                <li><Text type="p">{t('copyAsset.help.fixedReturn')}</Text></li>
            </ul>

            <Text type="h5" className="mb-1">{t('copyAsset.help.notCopiedTitle')}</Text>
            <ul className="mb-3">
                {NOT_COPIED_KEYS.map(key => (
                    <li key={key}><Text type="p">{t(key)}</Text></li>
                ))}
            </ul>

            <Text type="p">{t('copyAsset.help.rowLimit')}</Text>
        </Modal>
    )
}

export default CopyAssetHelpModal
